/**
 * 落地页 / 分享链接邀请码规则（与 pm/le、pm/lg、/register 等入口对齐）：
 *
 * 1. 仅识别 query 参数名：code
 * 2. 值会 trim；空字符串视为未携带邀请码
 * 3. 若 URL 中解析出有效邀请码，注册表单中该字段只读，不可改为其他码（防止换绑邀请关系）
 * 4. 未携带有效邀请码时，用户仍可自愿填写（保持可选）
 */

const REFERRER_QUERY_KEY = 'code'

function trimValue(v) {
  if (v == null) return ''
  return String(v).trim()
}

/**
 * @param {Record<string, string | string[] | undefined> | undefined} query - Vue Router location.query
 * @returns {string | null} 邀请码，无则 null
 */
export function getReferrerCodeFromQuery(query) {
  if (!query || typeof query !== 'object') return null
  const raw = query[REFERRER_QUERY_KEY]
  const s = trimValue(Array.isArray(raw) ? raw[0] : raw)
  return s || null
}

/**
 * 仅保留邀请码 query（code），用于从落地页跳转到 /register 时透传
 * @param {Record<string, unknown> | undefined} query
 * @returns {Record<string, string>}
 */
export function pickReferrerQuery(query) {
  if (!query || typeof query !== 'object') return {}
  const raw = query[REFERRER_QUERY_KEY]
  const s = trimValue(Array.isArray(raw) ? raw[0] : raw)
  if (!s) return {}
  return { [REFERRER_QUERY_KEY]: s }
}
